import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { FullScreenLoader } from 'layouts';
import { DialogManager } from 'components/dialog';

const RootLayout = () => {
  return (
    <>
      <Suspense fallback={<FullScreenLoader />}>
        <Outlet />
      </Suspense>

      <DialogManager />
    </>
  );
};

export default RootLayout;
